import { useState, useEffect } from 'react';
import { api } from '../utils/api';
import { parseError } from '../utils/helpers';

export const useAuth = () => {
    const [token, setToken] = useState(localStorage.getItem('token') || null);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || null);
    const [authMessage, setAuthMessage] = useState({ text: '', type: '' });
    const [authMode, setAuthMode] = useState('login');
    const [resetEmail, setResetEmail] = useState('');
    const [resetToken, setResetToken] = useState('');
    const [newPassword, setNewPassword] = useState('');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tokenParam = params.get('reset');
        const emailParam = params.get('email');
        if (tokenParam && emailParam) { 
            setResetToken(tokenParam); 
            setResetEmail(decodeURIComponent(emailParam)); 
            setAuthMode('reset'); 
        }
    }, []);

    const handleLogin = async (e, fetchInitialData, setTrainingDays) => {
        e.preventDefault(); setAuthMessage({ text: '', type: '' });
        try {
            const data = await api.fetch('/login', { method: 'POST', body: JSON.stringify({ identifier: e.target.identifier.value, password: e.target.password.value }), isLoginAttempt: true });
            setToken(data.token); 
            setUser(data.user); 
            if(setTrainingDays) setTrainingDays(data.user.training_days_per_week || 4);
            localStorage.setItem('token', data.token); 
            localStorage.setItem('user', JSON.stringify(data.user));
            if(fetchInitialData) fetchInitialData(data.token);
        } catch (error) { setAuthMessage({ text: parseError(error.message), type: 'error' }); }
    };

    const handleRegister = async (e) => {
        e.preventDefault(); setAuthMessage({ text: '', type: '' });
        const payload = { name: e.target.name.value, email: e.target.email.value, gender: e.target.gender.value, training_type: e.target.training_type.value, bot_field: e.target.bot_field.value };
        try {
            await api.fetch('/public/register', { method: 'POST', body: JSON.stringify(payload) });
            setAuthMessage({ text: 'Aanvraag ontvangen! Zodra de coach je goedkeurt, ontvang je een e-mail met je wachtwoord.', type: 'success' });
            setAuthMode('login'); e.target.reset();
        } catch (error) { setAuthMessage({ text: parseError(error.message), type: 'error' }); }
    };

    const handleForgotPassword = async (e) => {
        e.preventDefault(); setAuthMessage({ text: '', type: '' });
        try {
            const data = await api.fetch('/public/forgot-password', { method: 'POST', body: JSON.stringify({ email: e.target.forgot_email.value }) });
            setAuthMessage({ text: data.message, type: 'success' }); e.target.reset();
        } catch (error) { setAuthMessage({ text: parseError(error.message), type: 'error' }); }
    };

    const handleResetPassword = async (e) => {
        e.preventDefault(); if (!newPassword) return; setAuthMessage({ text: '', type: '' });
        try {
            const data = await api.fetch('/public/reset-password', { method: 'POST', body: JSON.stringify({ email: resetEmail, token: resetToken, newPassword: newPassword }) });
            setAuthMessage({ text: data.message, type: 'success' }); setNewPassword('');
            window.history.replaceState({}, document.title, window.location.pathname); setAuthMode('login');
        } catch (error) { setAuthMessage({ text: parseError(error.message), type: 'error' }); }
    };

    const logout = () => {
        setToken(null);
        setUser(null);
        localStorage.clear();
    };

    return {
        token, setToken, user, setUser,
        authMessage, setAuthMessage, authMode, setAuthMode,
        resetEmail, setResetEmail, resetToken, setResetToken,
        newPassword, setNewPassword,
        handleLogin, handleRegister, handleForgotPassword, handleResetPassword, logout
    };
};
